import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import SocialApps from '../SocialApps';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const AppsPromoHomeV2 = ({ appStoreLink, playStoreLink }) => {
  const { t } = useTranslation();
  return (
    <section className="appsContainer appsPromoRow">
      <div className="imageSectionNew">
        <div className="phomeImg">
          <LazyLoadImage
            src="/content/images/homepagev2/phone.png"
            height={407}
            width={382}
            alt=""
          />
        </div>
      </div>
      <div className="middleWrap">
        <div>
          <h2 className="heading desktop-only">
            {t('Keep your coupons handy with the free label')}&nbsp;
            <span>{t('SingleCare')}</span>&nbsp;
            <span className="appLabel">{t('app')}</span>
          </h2>
          <h2 className="heading mobile-only">
            {t('Find discounts anywhere you go with the')}&nbsp;
            <span>{t('SingleCare')}</span>&nbsp;
            <span className="appLabel">{t('app')}</span>
          </h2>

          <div className="ratingWrappper">
            <div>
              <a
                href={appStoreLink}
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare iOS App"
              >
                <LazyLoadImage
                  src="/content/images/footer/appStore.svg"
                  className="enImage"
                  alt={t('App Store footer')}
                />
                <LazyLoadImage
                  src="/content/images/homepagev2/app-store-badge-spanish.svg"
                  className="esImage"
                  alt={t('App Store badge spanish')}
                />
              </a>
              <a
                href={playStoreLink}
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare Android App"
              >
                <LazyLoadImage
                  src="/content/images/footer/google-play.svg"
                  className="enImage"
                  alt={t('Google play')}
                />
                <LazyLoadImage
                  src="/content/images/homepagev2/google-play-badge-spanish.svg"
                  className="esImage"
                  alt={t('Google play badge spanish')}
                />
              </a>
            </div>
            <div className="ratingSection">
              <LazyLoadImage
                src="/content/images/apps/rating-yellow.svg"
                className="ratingImg"
                alt=""
              />
              <span>{t('4.8 avg rating')}</span>
            </div>
          </div>
        </div>
        <div className="textSection desktop-only">
          <SocialApps
            isApps={true}
            isLandingPages={true}
            labelText={t('Text a link to download the app')}
            type={'mobileApps'}
            isNumberSendLandingPage={true}
          />
        </div>
      </div>
    </section>
  );
};

export default AppsPromoHomeV2;
